import { render, staticRenderFns } from "./ExpenseEditPage.vue?vue&type=template&id=2792dbc2&"
import script from "./ExpenseEditPage.vue?vue&type=script&lang=ts&"
export * from "./ExpenseEditPage.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports